import { GetTicketsByFiltersDtoProps } from "api/DTOs/GetTicketsByFiltersDto"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"
import { precisionNumber } from "utils/precisionNumber"

export const REEMBOLSO_TICKETS_COLUMNS = (t: TFunction) => {
  const columns = [
    {
      key: "fechaEmision",
      header: `${t("reembolsoTickets.table.headerDate")}`,
      field: "fechaEmision",
      className: "tw-text-text",
      sortable: true,
      sortfield: "fechaEmision",
      body: ({ fechaEmision }: GetTicketsByFiltersDtoProps) =>
        fechaEmision ? frontendDateFormat(new Date(fechaEmision)) : "-",
    },
    {
      key: "nombre",
      header: `${t("reembolsoTickets.table.headerName")}`,
      field: "nombre",
      className: "tw-text-text",
      sortable: true,
      sortfield: "nombre",
    },
    {
      key: "empleado",
      header: `${t("reembolsoTickets.table.headerEmployee")}`,
      field: "empleado",
      className: "tw-text-text",
      sortable: true,
      sortfield: "empleado",
    },
    {
      key: "Numero",
      header: `${t("reembolsoTickets.table.headerNumber")}`,
      field: "numero",
      className: "tw-text-text tw-text-left tw-cursor-default",
      sortable: true,
      sortfield: "numero",
    },
    {
      key: "Importe",
      header: `${t("reembolsoTickets.table.headerAmount")}`,
      field: "importe",
      className: "tw-text-text !tw-text-right",
      sortable: true,
      sortField: "Conceptos.Sum(c=>c.Cantidad*c.Precio)",
      alignCol: "right",
      body: ({ importe }: GetTicketsByFiltersDtoProps) =>
        `${new Intl.NumberFormat("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(precisionNumber(importe ?? 0))} €`,
    },
  ]
  return columns
}
